import _sfc_main from "./component-library103.mjs";
import "./component-library104.mjs";
import normalizeComponent from "./component-library92.mjs";
var _sfc_render = function render() {
  var _a;
  var _vm = this, _c = _vm._self._c;
  _vm._self._setupProxy;
  return _c("picture", [_vm._l(_vm.sourcesWithBreakpointReverse, function(entry, index) {
    return _c("source", { key: `${entry.name}-${index}`, attrs: { "srcset": entry.src, "media": entry.media, "type": entry.type } });
  }), _c("img", { key: _vm.src || "", class: _vm.imageClass, style: _vm.imageStyle, attrs: { "src": (_a = _vm.defaultImage) == null ? void 0 : _a.src, "alt": _vm.alt || "", "height": _vm.height, "width": _vm.width, "loading": _vm.lazy ? "lazy" : void 0 }, on: { "error": function($event) {
    return _vm.$emit("image-error", $event);
  } } })], 2);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "416b3234",
  null,
  null
);
const PictureElement = __component__.exports;
export {
  PictureElement as default
};
